import { createSlice } from "@reduxjs/toolkit";

// Helper function to get cart from localStorage
const getCartFromStorage = () => {
  try {
    const cartData = localStorage.getItem("cart");
    if (cartData) {
      const parsed = JSON.parse(cartData);
      const now = Date.now();
      const fiveHours = 5 * 60 * 60 * 1000; // 5 hours in milliseconds
      
      // Check if cart is older than 5 hours
      if (parsed.timestamp && (now - parsed.timestamp) > fiveHours) {
        localStorage.removeItem("cart");
        return [];
      }
      
      return parsed.items || [];
    }
    return [];
  } catch (error) {
    console.error("Error loading cart from localStorage:", error);
    localStorage.removeItem("cart");
    return [];
  }
};

// Helper function to save cart to localStorage
const saveCartToStorage = (cart) => {
  try {
    const cartData = {
      items: cart,
      timestamp: Date.now()
    };
    localStorage.setItem("cart", JSON.stringify(cartData));
  } catch (error) {
    console.error("Error saving cart to localStorage:", error);
  }
};

export const cartSlice = createSlice({
  name: "cart",
  initialState: {
    cart: getCartFromStorage(),
    // categoryList : [],
    // menuList : [],
    // selectedCategory : "",
    // selectedMenuItem : {}
  },
  reducers: {
    addCart: (state, action) => {
      const findIndex = state.cart.findIndex(
        (item) => item.id === action.payload.id
      );
      if (findIndex !== -1) {
        state.cart[findIndex] = action.payload;
      } else {
        state.cart.push(action.payload);
      }
      // Save to localStorage after updating cart
      saveCartToStorage(state.cart);
    },
    increaseQty: (state, action) => {},
    dicreaseQty: (state, action) => {},
    removeOrder: (state, action) => {
      const findIndex = state.cart.findIndex(
        (item) => item.id === action.payload
      );
      if (findIndex !== -1) {
        state.cart.splice(findIndex, 1); // Removes the element at the found index
      }
      // Save to localStorage after updating cart
      saveCartToStorage(state.cart);
    },
    resetCart: (state) => {
      state.cart = [];
      localStorage.removeItem("cart");
    },
    clearCartOnOrder: (state) => {
      state.cart = [];
      localStorage.removeItem("cart");
    },
  },
});
export const { addCart, removeOrder, resetCart, clearCartOnOrder } = cartSlice.actions;
export default cartSlice.reducer;
